import {
    baseUrl
} from '@/config/env';
import request from '@/router/axios';
import {
    parseParam
} from '@/util/util';
export const findDeclarationCode = (params) => {
    params = parseParam(params)
    params = params + "&type=WATERPROOF";
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/declaration_code?` + params,
        method: 'GET'
    })
}
export const addDeclarationCode = (params) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/declaration_code`,
        method: 'POST',
        data: params
    })
}
export const updateDeclarationCode = (params) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/declaration_code/` + params,
        method: 'PUT',
        data: params
    })
}

export const delDeclarationCode = (deleteOption, ids) => {
    let temp = ids.join(",")
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/pure_water_goods/${temp}?option=${deleteOption}`,
        method: 'DELETE'
    })
}
